import { Text } from "preact-i18n";

import { Modal } from "@revoltchat/ui";

import { determineFileSize1024 } from "../../../lib/fileSize";
import { noopTrue } from "../../../lib/js";

import { ModalProps } from "../types";

export default function FileTooLarge({
    filesize,
    ...props
}: ModalProps<"file_too_large">) {
    return (
        <Modal
            {...props}
            title={<Text id="app.special.modals.error" />}
            actions={[
                {
                    onClick: noopTrue,
                    confirmation: true,
                    children: <Text id="app.special.modals.actions.ok" />,
                },
            ]}>
            <Text
                id="error.FileTooLarge"
                fields={{
                    filesize: determineFileSize1024(filesize!),
                }}
            />
        </Modal>
    );
}
